<router-outlet class="dark:bg-slate-800"></router-outlet>